// export const BASE_URL = 'http://3.144.156.55:4000';
// export const BASE_URL = 'https://parks-counter-category-dee.trycloudflare.com';
// export const BASE_URL = 'http://3.22.235.46:4000';
 export const BASE_URL = 'https://api.goldsmithgracebay.com';
//export const BASE_URL = 'http://localhost:4000';
// export const BASE_URL = 'https://said-scored-coupled-diffs.trycloudflare.com';
